export default __webpack_public_path__ + "static/media/reference.370480e9.png";